import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function wsUrl(channel) {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api/ws/${channel}`;
}

const KEY = "rmn_subscriber";

export function getSession() {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch {
    return null;
  }
}

export function setSession(sub) {
  localStorage.setItem(KEY, JSON.stringify(sub));
}

export function clearSession() {
  localStorage.removeItem(KEY);
}

export function getVisitorId() {
  let id = localStorage.getItem("rmn_visitor");
  if (!id) {
    id = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("rmn_visitor", id);
  }
  return id;
}
